namespace $.$$ {
	$mol_style_define( $mol_book2_catalog, {
		
		Menu_filter: {
			flex: {
				shrink: 0,
				grow: 0,
			},
			alignSelf: 'stretch',
		},
		
		Menu_item: {
			align: {
				items: 'flex-start',
			},
		},
		
		Menu_link: {
			flex: {
				grow: 1,
				shrink: 1,
				wrap: 'wrap',
			},
		},
		
	})

}
